'use client';

import classNames from 'classnames';
import { useState } from 'react';
import { ClipboardDocumentIcon as Copy, CheckIcon as Check } from '@heroicons/react/24/outline';

import { Global } from '@/types/sanity.types';
import { CopyTextProps } from './CopyText';
import { ButtonGhost } from '../Buttons';

type CopyTextClientProps = CopyTextProps & {
  global: Global;
};

export const CopyTextClient = ({ children, global }: CopyTextClientProps) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const handleClick = () => {
    navigator.clipboard.writeText(String(children));
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <ButtonGhost
      onClick={handleClick}
      className={classNames('text-inherit opacity-50 hover:opacity-100 [&]:font-normal', {
        '[&]:text-green-500': isCopied,
        '[&]:opacity-100': isCopied,
        '[&&]:bg-green-500/10': isCopied,
      })}
    >
      {!isCopied ? (
        <>
          <Copy className="w-4" /> {global.misc?.copy}
        </>
      ) : (
        <>
          <Check className="w-4" /> {global.misc?.copied}
        </>
      )}
    </ButtonGhost>
  );
};
